import React, { useEffect, useReducer, useState } from 'react';
import {
  GradingQuestionActionType,
  gradingQuestionsReducer,
} from './GradingQuestionReducer';
import { produce } from 'immer';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { Button, Card, CardContent, Grid } from '@mui/material';
import GradingCardRenderer from './GradingCardRenderer';
import APICaller, { MethodType } from '../common/APICaller';
import CustomizedModal from '../common/CustomizedModal';
import { AssessmentQuestionType } from '../../utils/assessmentsQuestions';

const AssessmentGradingForm: React.FC = () => {
  const { jobId, applicantId, assessmentId } = useParams();
  const [searchParams] = useSearchParams();
  const isViewMode = searchParams.get('view') === 'true';
  const [openModal, setOpenModal] = useState<boolean>(false);
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
  const [autoGraded, setAutoGraded] = useState<boolean>(false);
  const navigate = useNavigate();
  const notificationsMsgs = [
    'All the multiple choice questions are auto-graded!',
    'Progress is saved!',
    'You cannot change the grading after submission!',
  ];
  const [notificationsMsg, setNotificationMsg] = useState<string>(
    notificationsMsgs[0],
  );
  const [questions, dispatch] = useReducer(
    produce(gradingQuestionsReducer),
    [],
  );
  // console.log(jobId, applicantId, assessmentId);
  console.log(questions);
  useEffect(() => {
    APICaller(
      `/metrics/jobs/${jobId}/applicants/${applicantId}/assessments/${assessmentId}/questions-answers`,
      MethodType.GET,
    )
      .then(res => {
        console.log(res);
        if (res.assessment) {
          dispatch({
            type: GradingQuestionActionType.Init,
            payload: {
              data: res.assessment,
            },
          });
          if (!autoGraded) {
            autoGradeQuestions();
          }
        }
      })
      .catch(e => {
        console.log(e);
      });
  }, [autoGraded]);

  const autoGradeQuestions = () => {
    APICaller(
      `/metrics/jobs/${jobId}/applicants/${applicantId}/assessments/${assessmentId}/autograde`,
      MethodType.PUT,
    )
      .then(res => {
        console.log(res);
        if (res.errorMessage) {
          setOpenModal(true);
          setNotificationMsg(res.errorMessage);
        } else {
          setAutoGraded(true);
        }
      })
      .catch(e => {
        console.log(e);
      });
  };

  const saveGradeHandler = () => {
    const grades = questions
      .filter(q => q.type !== AssessmentQuestionType.MultipleChoice && q.type !== AssessmentQuestionType.SingleChoice)
      .map(q => {
        return {
          questionId: q.questionId,
          answerId: q.answerId,
          grade: q.grade || 0,
        };
      });
    const payload = { grades };
    APICaller(
      `/metrics/jobs/${jobId}/applicants/${applicantId}/assessments/${assessmentId}/save-grade?submit=0`,
      MethodType.PUT,
      payload,
    )
      .then(res => {
        console.log(res);
        if (!res.errorMessage) {
          setOpenModal(true);
          setNotificationMsg(notificationsMsgs[1]);
        }
      })
      .catch(e => {
        console.log(e);
      });
  };

  const submitGradeHandler = () => {
    setIsSubmitting(true);
    setOpenModal(true);
    setNotificationMsg(notificationsMsgs[2]);
  };
  const modalClickHandler = () => {
    if (isSubmitting) {
      const grades = questions
        .filter(q => q.type !== AssessmentQuestionType.MultipleChoice && q.type !== AssessmentQuestionType.SingleChoice)
        .map(q => {
          return {
            questionId: q.questionId,
            answerId: q.answerId,
            grade: q.grade || 0,
          };
        });
      const payload = { grades };
      APICaller(
        `/metrics/jobs/${jobId}/applicants/${applicantId}/assessments/${assessmentId}/save-grade?submit=1`,
        MethodType.PUT,
        payload,
      )
        .then(res => {
          console.log(res);
          if (!res.errorMessage) {
            navigate(
              `/grade-assessment-list/job/${jobId}/applicant/${applicantId}`,
            );
          } else {
            alert(res.errorMessage);
          }
        })
        .catch(e => {
          console.log(e);
        });
    }
    setOpenModal(false);
  };
  return (
    <Card>
      <CardContent>
        <Grid flexDirection="column" rowGap={2} container justifyItems="center">
          {questions.map((q, i) => {
            return (
              <>
                <GradingCardRenderer key={i} data={q} dispatch={dispatch} isViewMode={isViewMode} />
              </>
            );
          })}
        </Grid>
        <CustomizedModal
          open={openModal}
          clickHandler={modalClickHandler}
          title="Notification"
          description={notificationsMsg}
          buttonText="I See!"
        />
        <Button
          variant="outlined"
          sx={{
            width: '20%',
            backgroundColor: 'white',
            color: 'var(--ttg-black)',
            borderColor: 'var(--ttg-black)',
            '&:hover': {
              backgroundColor: '#f5f5f5',
              borderColor: 'var(--ttg-black)',
            },
            margin: '20px 5px 0 5px',
            padding: '10px 20px',
            cursor: 'pointer',
          }}
          onClick={() => {
            const viewParam = isViewMode ? '?view=true' : '';
            navigate(`/grade-assessment-list/job/${jobId}/applicant/${applicantId}${viewParam}`);
          }}
        >
          Go Back
        </Button>
        {!isViewMode && (
          <>
            <Button
              onClick={saveGradeHandler}
              variant="contained"
              sx={{
                backgroundColor: 'var(--ttg-black)',
                '&:hover': {
                  backgroundColor: 'var(--ttg-black)',
                },
                margin: '20px 5px 0 5px',
                padding: '10px 20px',
                cursor: 'pointer',
                width: '200px',
              }}
            >
              {'Save Progress'}
            </Button>
            <Button
              onClick={submitGradeHandler}
              variant="contained"
              sx={{
                backgroundColor: 'var(--ttg-green)',
                '&:hover': {
                  backgroundColor: 'var(--ttg-green)',
                },
                margin: '20px 5px 0 5px',
                padding: '10px 20px',
                cursor: 'pointer',
                width: '200px',
              }}
            >
              {'Submit'}
            </Button>
          </>
        )}
      </CardContent>
    </Card>
  );
};

export default AssessmentGradingForm;
